
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../../store';
import { TrendStockContext } from '../../models/trend-stock.state';
import { Injectable } from '@angular/core';

export const TREND_STOCK_CONTEXT = 'trendstock/CONTEXT';



@Injectable()
export class TrendStockActions {


    constructor(private ngRedux: NgRedux<IAppState>) {

    }

    trendstockContext(trendstockState: TrendStockContext) {
        this.ngRedux.dispatch({
            type: TREND_STOCK_CONTEXT,
            trendstockState
        });
        return {
            type: TREND_STOCK_CONTEXT,
            trendstockState
        };
    }

}